import { FC } from "react";

import { ColorIconButton } from "../../../controls";
import { ISpecificReasonProps } from "./passenger-addition.models";
import { PassengerAdditionRowStyled } from "./passenger-addition.styled";

export const PassengerAdditionReasonRow: FC<ISpecificReasonProps> = ({
  name,
  price,
  onEdit,
  onClear,
}) => {
  return (
    <PassengerAdditionRowStyled
      data-e2e-template="passenger-additions-template"
      data-e2e-field-name={name}
    >
      <p>{name}</p>
      <p>{price}</p>
      <div>
        <ColorIconButton iconType="EDIT" onClick={onEdit} />
        <ColorIconButton iconType="DELETE" onClick={onClear} />
      </div>
    </PassengerAdditionRowStyled>
  );
};
